import { useSiteConfigs } from "@/features/ai-model-selection/hooks/use-site-configs";

/**
 * Whether this deployment can issue partner loyalty points.
 *
 * Sourced from `/site-configs`, which the app already loads and caches, so
 * this costs no extra request. Fails closed: while the config is loading, or
 * if it fails, or against an older API that doesn't send the field, the
 * feature reads as off. Better to omit the option than to offer one every
 * request would reject.
 */
export const useCosmopointsEnabled = (): {
  isEnabled: boolean;
  isLoading: boolean;
} => {
  const { data, isLoading } = useSiteConfigs();

  return {
    isEnabled: data?.data?.cosmopointsEnabled === true,
    isLoading,
  };
};
